import PropTypes from "prop-types";
import React from "react";
import "./style.css";

const TOP_BAR_MESSAGE_TYPES = {
  Error: { className: "error" },
  Info: { className: "info" },
};

/**
 * Renders a user-friendly message bar in single line with the type and message separated by a colon ':'
 * @param {object} props - Component props
 * @param {string} props.type - type of the message (Lookup TOP_BAR_MESSAGE_TYPES keys)
 * @param {string} props.message - message be displayed
 * @returns {JSX.Element} rendered component
 */
const TopMessageBar = (props) => {
  const { type, message } = props;
  const className = TOP_BAR_MESSAGE_TYPES.hasOwnProperty(type)
    ? TOP_BAR_MESSAGE_TYPES[type].className
    : TOP_BAR_MESSAGE_TYPES.Info.className;
  return <div data-testid="top-message-bar" className={`top-bar-message ${className}`}>{`${type}: ${message}`}</div>;
};

TopMessageBar.propTypes = {
  type: PropTypes.oneOf(["Error", "Info"]).isRequired,
  message: PropTypes.string.isRequired,
};

TopMessageBar.defaultProps = {
  type: "UNKNOWN",
  message: "",
};

export default TopMessageBar;



// WEBPACK FOOTER //
// ./src/libraries/TopMessageBar/index.jsx